import React from 'react'
import { createRoot } from 'react-dom/client'
import MainBoundary from '@/v2/components/boundaries/MainBoundary.jsx'
import AppV2 from '@/v2/index.jsx'

document.addEventListener('DOMContentLoaded', () => {
  const clearworksApp = document.createElement('div')
  clearworksApp.setAttribute('id', 'clearworks-app')
  clearworksApp.style.width = '100%'
  clearworksApp.style.minHeight = '100vh'
  clearworksApp.style.minHeight = '100dvh'

  const rootElement = document.body.appendChild(clearworksApp)

  if (!window.location.href.includes('/v2')) {
    const url = window.location.href.replace(
      window.location.origin,
      `${window.location.origin}/v2`
    )
    window.location.href = url
    return null
  }

  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(
      <MainBoundary showSVG={false}>
        <AppV2 />
      </MainBoundary>
    )
  }
})
